
import React, { useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
import "./NavigationBar.css";
import ima from "../img/logooo.png";

const COLORS = {
  dark: "#081a2f",
  accent: "#0693e3",
  white: "#ffffff",
};

const Styles = styled.div`
  direction: rtl;
  position: sticky;
  top: 0;
  z-index: 999;
  width: 100%;
  background: ${COLORS.dark};
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.15);

  .main-navbar {
    position: relative;
    min-height: 72px;
    padding: 10px 4%;
    background: ${COLORS.dark};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .navbar-collapse {
    justify-content: center;
  }

  .navbar-nav {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .nav-link {
    color: ${COLORS.white} !important;
    font-size: 16px;
    font-weight: 600;
    padding: 10px 16px !important;
    border-radius: 8px;
    transition: all 0.25s ease;
    text-decoration: none;
    cursor: pointer;
  }

  .nav-link:hover,
  .nav-link.active {
    color: ${COLORS.accent} !important;
    background: rgba(255, 255, 255, 0.08);
  }

  .side-actions {
    position: absolute;
    top: 50%;
    left: 4%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .phone-button {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 10px 20px;
    background: ${COLORS.accent};
    color: white;
    border: 1px solid ${COLORS.accent};
    border-radius: 25px;
    text-decoration: none;
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    transition: 0.25s ease;
  }

  .phone-button:hover {
    background: #087fc0;
    color: white;
    transform: translateY(-2px);
  }

  .mobile-phone-button {
    display: none;
  }

  .instagram-button {
    position: absolute;
    top: 50%;
    right: 4%;
    transform: translateY(-50%);
    width: 43px;
    height: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background: linear-gradient(
      45deg,
      #feda75,
      #fa7e1e,
      #d62976,
      #962fbf,
      #4f5bd5
    );
    border-radius: 13px;
    font-size: 23px;
    text-decoration: none;
    transition: 0.25s ease;
  }

  .instagram-button:hover {
    color: white;
    transform: translateY(-50%) scale(1.1);
  }

  .brand-section {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 20px;
    background: ${COLORS.dark};
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  .brand-link {
    display: flex;
    align-items: center;
    gap: 12px;
    color: white;
    text-decoration: none;
    font-size: 19px;
    font-weight: 800;
    transition: 0.25s ease;
  }

  .brand-link:hover {
    color: ${COLORS.accent};
  }

  .brand-logo {
    width: 185px;
    height: 48px;
    object-fit: contain;
  }

  @media (max-width: 991px) {
    .main-navbar {
      display: none;
    }

    .brand-section {
      min-height: 68px;
      padding: 10px 65px;
    }

    .brand-link {
      font-size: 15px;
    }

    .brand-logo {
      width: 95px;
      height: 42px;
    }

    .mobile-phone-button {
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 43px;
      height: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${COLORS.accent};
      color: white;
      border-radius: 50%;
      font-size: 19px;
      text-decoration: none;
      transition: background 0.25s ease;
      z-index: 2;
    }

    .mobile-phone-button:hover {
      background: #087fc0;
      color: white;
    }
  }

  @media (max-width: 480px) {
    .brand-link {
      font-size: 13px;
      gap: 7px;
    }

    .brand-logo {
      width: 85px;
      height: 38px;
    }

    .mobile-phone-button {
      width: 40px;
      height: 40px;
      font-size: 18px;
    }
  }
`;

function openTerms() {
  const fileName = "/תקנון-שימוש-באתר - רישוי עסקים ישראל.pdf";

  window.open(
    encodeURI(fileName),
    "_blank",
    "noopener,noreferrer"
  );
}

export const NavigationBar = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const shouldScroll = sessionStorage.getItem("scrollAfterNavigation");

    if (shouldScroll === "true") {
      sessionStorage.removeItem("scrollAfterNavigation");

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.scrollBy({
            top: 500,
            behavior: "smooth",
          });
        });
      });
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    }
  }, [location.pathname]);

  const navigateAndScroll = (path) => {
    if (location.pathname === path) {
      window.scrollBy({
        top: 500,
        behavior: "smooth",
      });
      return;
    }

    sessionStorage.setItem("scrollAfterNavigation", "true");
    history.push(path);
  };

  return (
    <Styles>
      <Navbar expand="lg" className="main-navbar">
        <a
          href="https://www.instagram.com/rishui_asakim_israel/"
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-button"
          aria-label="עקבו אחרינו באינסטגרם"
          title="אינסטגרם"
        >
          <FaInstagram />
        </a>

        <div className="side-actions">
          <a
            href="tel:0524816141"
            className="phone-button"
            aria-label="התקשרו אלינו 052-481-6141"
          >
            <FaPhoneAlt />
            052-481-6141
          </a>
        </div>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav>
            <button
              type="button"
              className="nav-link"
              onClick={() => navigateAndScroll("/")}
              style={{
                background: "transparent",
                border: "none",
                fontFamily: "inherit",
              }}
            >
              דף הבית
            </button>

            <button
              type="button"
              className="nav-link"
              onClick={() => navigateAndScroll("/about")}
              style={{
                background: "transparent",
                border: "none",
                fontFamily: "inherit",
              }}
            >
              אודות
            </button>

            <button
              type="button"
              className="nav-link"
              onClick={() => navigateAndScroll("/customers")}
              style={{
                background: "transparent",
                border: "none",
                fontFamily: "inherit",
              }}
            >
              לקוחותינו
            </button>

            <button
              type="button"
              className="nav-link"
              onClick={() => navigateAndScroll("/contact")}
              style={{
                background: "transparent",
                border: "none",
                fontFamily: "inherit",
              }}
            >
              יצירת קשר
            </button>

            <button
              type="button"
              onClick={openTerms}
              className="nav-link"
              style={{
                background: "transparent",
                border: "none",
                fontFamily: "inherit",
              }}
            >
              תקנון האתר
            </button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <div className="brand-section">
        <a
          href="tel:0524816141"
          className="mobile-phone-button"
          aria-label="התקשרו אלינו"
          title="התקשרו אלינו"
        >
          <FaPhoneAlt />
        </a>

        <Fade bottom>
          <Link to="/" className="brand-link">
            רישוי עסקים ישראל
            <img
              className="brand-logo"
              src={ima}
              alt="רישוי עסקים ישראל"
            />
          </Link>
        </Fade>
      </div>
    </Styles>
  );
};

export default NavigationBar;
